import { render, staticRenderFns } from "./VacationConfirmAwaitingWidget.vue?vue&type=template&id=30832e07&scoped=true&"
import script from "./VacationConfirmAwaitingWidget.vue?vue&type=script&lang=js&"
export * from "./VacationConfirmAwaitingWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30832e07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30832e07')) {
      api.createRecord('30832e07', component.options)
    } else {
      api.reload('30832e07', component.options)
    }
    module.hot.accept("./VacationConfirmAwaitingWidget.vue?vue&type=template&id=30832e07&scoped=true&", function () {
      api.rerender('30832e07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/widgets/VacationConfirmAwaitingWidget.vue"
export default component.exports